import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './Containers/App'
import './root.css'
import * as serviceWorker from './serviceWorker'
import "./i18n.js"
const rootElement = document.getElementById('root')
const root = createRoot(rootElement)

root.render(<App />)

serviceWorker.unregister()